import autobind from 'class-autobind';

import EventTarget from '@/util/EventTarget.js'
import { findUpTagByClass } from '@/util/findUpTag.js'
import { getIntersects, getBounds, getMaxRectInBounds} from '@/util/bounds.js';
import { defaultMarquee } from '@/reducer/tool';

import { getAlignments, HORIZONTAL, VERTICAL, maxSnapDistancePixels, POSITION, DIMENSION, GUTTER } from '@/util/alignment.js';
import content from '@/action/content';

export default class SelectHandler {
   constructor(host) {
        autobind(this);

        this.host = host;
   }

   toggleSelection(id) {
        const alreadySelected = this.host.props.content.selection.indexOf(id) !== -1;
        if (alreadySelected) {
            this.host.props.removeSelection([id]);
        } else {
            this.host.props.addSelection([id]);
        }
    }
   
   tap(event) {
       console.log('TAP?!')
        let gestureTarget = event.detail.gestureStartTarget;

        const textfieldElement = findUpTagByClass(gestureTarget, 'Textfield');
        const isTextfield = textfieldElement !== null;
        if (isTextfield) {
            gestureTarget = textfieldElement;
        }
        // console.log('isTextfield', isTextfield, textfieldElement);

        // console.log('gesture targ', gestureTarget);
        const isDraggable = gestureTarget && gestureTarget.classList && gestureTarget.classList.contains('draggable');

        const isTriggersDeselect = (gestureTarget && gestureTarget.className && gestureTarget.className.split) ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false; //fillContainer
        


        if (isDraggable ) {
            //this.state.multiselect || 
            if (this.host.props.multiselect) {
                // console.log("TOGGLE SEL! A")
                this.toggleSelection(gestureTarget.id);
            } else {
                // console.log("SET SEL GESTURE! A")
                this.host.props.setSelection([gestureTarget.id]);
            }

            if (this.host.props.content.active.indexOf(gestureTarget.id) == -1)
            {
                this.host.props.setActive();
            }
        }  else if (isTriggersDeselect) {
            this.host.props.setSelection();
            this.host.props.setActive();

            if (this.host.props.content.hover.length !== 0) {
                // console.log('I setHover');
                this.host.props.setHover();
            }
        }

    }

    startdrag(event){
        console.log('EVENT:', 'start drag', event);
        this.host.gestureStartScale = this.host.current.scale;

        if (!event.detail) {
            // Safari zoom gesture
            console.log('safari zoom gesture');
            return;
        }

        let gestureTarget = event.detail.gestureStartTarget;

        const textfieldElement = findUpTagByClass(gestureTarget, 'Textfield');
        const isTextfield = textfieldElement !== null;
        if (isTextfield) {
            gestureTarget = textfieldElement;
        }
        // console.log('isTextfield', isTextfield, textfieldElement);
        

        const isDraggable = gestureTarget && gestureTarget.classList.contains('draggable');

        if (gestureTarget) {
            // const isTriggersDeselect = gestureTarget ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false;
            const id = gestureTarget.id;
            const alreadySelected = this.host.props.content.selection.indexOf(id) !== -1;
            if (isDraggable && !alreadySelected) {
                //this.state.multiselect ||
                if (this.host.props.multiselect) {
                    // console.log("TOGGLE SEL! B")
                    this.toggleSelection(gestureTarget.id);
                } else {
                    // console.log("SET SEL GESTURE! B", this)
                    this.host.props.setSelection([gestureTarget.id]);
                }
                // this.props.editSelected();
                // self.props.setSelection(e.target.id);
            } else {
                console.log('start drag?')
            }

            this.host.handleGestureChanged(event);
        }
        

    }


    change(event) {
        const dx = event.detail.delta.pos.x / this.host.current.scale;
        const dy = event.detail.delta.pos.y / this.host.current.scale;


        const isTextfieldSelected = this.host.props.content.selection.length == 1 
        && 
        this.host.props.content.media.find((x)=>{return x.id == this.host.props.content.selection[0]}).type == 'text';


        const isActiveTextfieldSelected = isTextfieldSelected 
        &&  this.host.props.content.selection[0] == this.host.props.content.active[0];

        let gestureTarget = event.detail.gestureStartTarget;

        const textfieldElement = findUpTagByClass(gestureTarget, 'Textfield');
        const isTextfield = textfieldElement !== null;
        if (isTextfield) {
            gestureTarget = textfieldElement;
        }
        // console.log('isTextfield', isTextfield, textfieldElement);
        

        const isDraggable = gestureTarget && gestureTarget.classList.contains('draggable');

        if (gestureTarget) {
            // const isTriggersDeselect = gestureTarget ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false;
            const id = gestureTarget.id;
            const alreadySelected = this.host.props.content.selection.indexOf(id) !== -1;

            if (!isActiveTextfieldSelected && isDraggable && (dx !== 0 || dy !== 0)) {
                this.host.didDrag =  true;
                // console.log('drag')
                this.host.props.moveSelection(
                    dx,
                    dy
                );
            } else {
                // console.log("[[[  marquee?  ]]]", event.detail.start.pos.x, event.detail.delta.pos.x, event.detail.current.pos.x, this.host.props.scale, this.host.props.panX, this.host.props.width, 'x', this.host.props.height)
                this.host.didDrag =  false; // ????

                const isBg = gestureTarget ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false;
                //gestureTarget.id == 'background-grid' : false;
        
                if (isBg) {


                    const startX = (event.detail.start.pos.x - this.host.props.width/2)/ this.host.props.scale - this.host.props.panX;
                    const startY = (event.detail.start.pos.y - this.host.props.height/2)/ this.host.props.scale - this.host.props.panY;
            
                    const endX = (event.detail.current.pos.x - this.host.props.width/2)/ this.host.props.scale - this.host.props.panX;
                    const endY = (event.detail.current.pos.y - this.host.props.height/2)/ this.host.props.scale - this.host.props.panY;
            
                    const bounds = {
                        minX: Math.min(startX, endX),
                        minY: Math.min(startY, endY),
                        maxX: Math.max(startX, endX),
                        maxY: Math.max(startY, endY)
                    };
        
                    // console.log('set marquee', bounds);

                    this.host.props.setMarquee(bounds);

                    const pendingMultiselect = getIntersects(this.host.props.content.media, bounds);
                    // console.log('pendingMultiselect', pendingMultiselect,this.host.props.content.media);
                    this.host.props.setHover(pendingMultiselect);
                }


            }
        }

    }


    enddrag(event) { 
        console.log('enddrag', event);
        this.host.props.setMarquee();

        let gestureTarget = event.detail.gestureStartTarget;

        const isBg = gestureTarget ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false;
        //gestureTarget.id == 'background-grid' : false;


        const halfW = this.host.props.width/2;
        const halfH = this.host.props.height/2;

        if (isBg) {
            console.log('bg')

            const startX = (event.detail.start.pos.x - halfW)/ this.host.props.scale - this.host.props.panX;
            const startY = (event.detail.start.pos.y - halfH)/ this.host.props.scale - this.host.props.panY;
    
            const endX = (event.detail.end.pos.x - halfW)/ this.host.props.scale - this.host.props.panX;
            const endY = (event.detail.end.pos.y - halfH)/ this.host.props.scale - this.host.props.panY;
    
            const bounds = {
                minX: Math.min(startX, endX),
                minY: Math.min(startY, endY),
                maxX: Math.max(startX, endX),
                maxY: Math.max(startY, endY)
            };

            // console.log('set marquee', bounds);

            this.host.props.setMarquee(defaultMarquee);

            const pendingMultiselect = getIntersects(this.host.props.content.media, bounds);
            
            this.host.props.addSelection(pendingMultiselect);
            
            // console.log('pendingMultiselect', pendingMultiselect,this.host.props.content.media);
            // this.host.props.setHover(pendingMultiselect);
            this.host.props.setHover();
        } else if (this.host.props.content.selection.length > 0) {

            // snap?
            console.log('snap')
    
            const bounds = {
                minX: (-this.host.props.panX - halfW / this.host.props.scale),
                minY: (-this.host.props.panY - halfH / this.host.props.scale),
                maxX: (-this.host.props.panX + halfW / this.host.props.scale),
                maxY: (-this.host.props.panY + halfH / this.host.props.scale)
            }
    
            const wasResizing = (this.host.resizeHandle == null) ? false : true;

            const alignments = getAlignments (this.host.props.media, this.host.props.content.selection, bounds, this.host.props.scale, wasResizing);
    
            let alignmentAdjust = alignments; 
            //.filter((alignment)=>{
            //     // console.log(this.props.alignments, alignment)
            //     if (alignment.source == item) return true;
            // });

            // console.log('alignmentAdjust', alignmentAdjust);
            let dx = 0;
            let dy = 0;
            let newWidth, newHeight;

            let adjustmentType;

            alignmentAdjust.map((alignment) => {

                // console.log('type', alignment.type);

                adjustmentType = alignment.type;

                if (alignment.type == POSITION) {
                    let offset = alignment.targetPos - alignment.sourcePos;
                    let dist = Math.round(Math.abs(offset))
    
                    if (dist <= maxSnapDistancePixels / this.host.props.scale) {
                        if (alignment.axis === HORIZONTAL) {
                            dx = offset
                        } else if (alignment.axis === VERTICAL) {
                            dy = offset
                        } 
                    }
                } else if (alignment.type == DIMENSION) {
                    
                    let offset = alignment.targetDim - alignment.sourceDim;
                    let dist = Math.round(Math.abs(offset))
    
                    if (dist <= maxSnapDistancePixels / this.host.props.scale) {
                        if (alignment.axis === HORIZONTAL) {
                            dx = (alignment.sourceDim - alignment.targetDim) * this.host.props.scale;
                            newWidth = alignment.targetDim;
                            if (newHeight == undefined) {
                                console.log('need height!', alignment);
                                newHeight = alignment.source.nativeHeight*10;
                            }
                        } else if (alignment.axis === VERTICAL) {
                            dy = (alignment.sourceDim - alignment.targetDim) * this.host.props.scale;
                            newHeight = alignment.targetDim;
                            if (newWidth == undefined) {
                                console.log('need width!', alignment);
                                newWidth = alignment.source.nativeWidth*10
                            }
                        }
                    }


                    // if (this.host.props.aspectLock) {
                    //     const newBoundingBox = getMaxRectInBounds(alignment.source.width, alignment.source.height, newWidth, newHeight);
                    //     newWidth = newBoundingBox.width;
                    //     newHeight = newBoundingBox.height;
                    //     console.log('content alignment dimension bb:', alignment, newBoundingBox, alignment.source.width, alignment.source.height, newWidth, newHeight);
                    // }

                } else if (alignment.type == GUTTER) {
                    let offset = alignment.sourceGutter.gutter - alignment.targetGutter.gutter;
                    let dist = Math.round(Math.abs(offset))
    
                    if (dist <= maxSnapDistancePixels / this.host.props.scale) {
                        if (alignment.axis === HORIZONTAL) {
                            if (this.host.props.content.selection.indexOf(alignment.sourceGutter.itemA.id) !== -1) {
                                dx = offset
                            }
                            if (this.host.props.content.selection.indexOf(alignment.sourceGutter.itemB.id) !== -1) {
                                dx = -offset
                            }                            
                        } else if (alignment.axis === VERTICAL) {
                            if (this.host.props.content.selection.indexOf(alignment.sourceGutter.itemA.id) !== -1) {
                                dy = offset
                            }
                            if (this.host.props.content.selection.indexOf(alignment.sourceGutter.itemB.id) !== -1) {
                                dy = -offset
                            }    
                        } 
                    }
                } 
            });

            if (dx !== 0 || dy !== 0) {
                if (adjustmentType == POSITION) {
                    this.host.props.moveSelection(
                        dx,
                        dy
                    );
                } else if (adjustmentType == DIMENSION) {

                    // console.log('event', event)
                    const contentBounds = getBounds( this.host.props.media, this.host.props.content.selection );

                    const targetBounds = {
                        width: newWidth, // contentBounds.maxX - contentBounds.minX + dx,
                        height: newHeight, // contentBounds.maxY - contentBounds.minY + dy
                    }

                    console.log('do resize on end', 'dx', dx, 'dy', dy, 'contentB', contentBounds,  'targetBounds', targetBounds, dy/dx, targetBounds.height / targetBounds.width, 'aspect?', this.host.props.aspectLock);

                    this.host.props.resizeSelection(
                        contentBounds,
                        targetBounds,
                        this.host.resizeHandle,
                        this.host.props.aspectLock
                    );
                } else if (adjustmentType == GUTTER) {
                    this.host.props.moveSelection(
                        dx,
                        dy
                    );
                } 

            }


        }
        // setTimeout(()=>{

        this.host.props.deactivate(this.host.resizeHandle);
        this.host.resizeHandle = null;
        // }, 0)
    }

}
